import React from 'react';
import Accordion from 'core/components/Accordion';
import FieldsArrayWrapper from 'pages/Dashboard/pages/Charts/pages/Details/components/FieldsArrayWrapper';
import AttachmentItem from 'pages/Dashboard/pages/Billing/ClaimForm/Attachments/AttachmentItem';

const defaultAttachmentData = Object.freeze({
  attachmentControlNumber: '',
  patientMultiMediaId: null,
  attachmentReportTypeCode: null,
  transmissionCode: null,
});

export default function ClaimAttachments() {
  return (
    <Accordion
      defaultExpanded
      header="Attachments"
      disableGutters
      headerClasses={{
        root: '!px-2 !py-1 !min-h-[initial] !bg-gray-100 !text-gray-600 !font-semibold text-sm',
        content: '!m-0',
      }}
      detailsClasses={{ root: '!p-2' }}
    >
      <div className="populate-form flex flex-col gap-4">
        <FieldsArrayWrapper
          shouldValidate={false}
          formKey="claimAttachments"
          FieldComponent={AttachmentItem}
          maxItems={10}
          append={{
            text: 'Add Attachment',
            tooltip: 'Maximum 10 attachments allowed',
          }}
          getDefaultValue={() => defaultAttachmentData}
          classes={{
            field: '!w-full',
          }}
        />
      </div>
    </Accordion>
  );
}
